/**
 * Live "Matches" under the search box (design P02). Small, separate requests to GET /product/products
 * so the list itself does not change until the search is applied (Enter).
 */
import { SearchScope } from "./productListFilters";

export type MatchQuery = { by: "name" | "id" | "xuid" | "tags" | "color"; param: string };

/** Which product-list params to try for the typed text. "Everything" tries the name and the product ID. */
export function matchQueries(scope: SearchScope, text: string): MatchQuery[] {
  const value = text.trim();
  if (value.length < 2) return [];
  switch (scope) {
    case "name":
      return [{ by: "name", param: "name" }];
    case "productId":
      return [{ by: "id", param: "productId" }];
    case "xuid":
      return [{ by: "xuid", param: "xuid" }];
    case "tags":
      return [{ by: "tags", param: "tags" }];
    case "color":
      return [{ by: "color", param: "color" }];
    default:
      return [
        { by: "id", param: "productId" },
        { by: "name", param: "name" },
      ];
  }
}

export function matchUrl(base: string, query: MatchQuery, text: string, limit = 4): string {
  return `${base}/product/products?offset=0&limit=${limit}&${query.param}=${encodeURIComponent(text.trim())}&sortBy=createdAt&orderBy=-1&includeAiSuggestions=false`;
}

export type SearchMatch = { product: any; byId: boolean };

/** One list, ID hits first, no repeats, at most `max`. */
export function mergeMatches(groups: Array<{ by: MatchQuery["by"]; docs: any[] }>, max = 5): SearchMatch[] {
  const out: SearchMatch[] = [];
  const seen = new Set<string>();
  const ordered = groups.slice().sort((a, b) => (a.by === "id" ? -1 : 0) - (b.by === "id" ? -1 : 0));
  ordered.forEach(({ by, docs }) =>
    (Array.isArray(docs) ? docs : []).forEach((product) => {
      const key = String(product?._id || product?.productUniqueId || "");
      if (!key || seen.has(key) || out.length >= max) return;
      seen.add(key);
      out.push({ product, byId: by === "id" || by === "xuid" });
    })
  );
  return out;
}
